import React from 'react'
import {
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { StyleSheet } from 'react-native'

import MenuIcon from 'app/icons/Menu'
import Menu, { MenuItem } from 'app/components/Menu'
import { logout } from 'app/utils/common'

interface Props {
  iconColor?: string
}

const HeaderMenu = ({ iconColor }: Props) => {
  return (
    <Menu
      triggerElement={
        <MenuIcon
          height={24}
          width={24}
          style={COMMON_STYLES.mh1}
          fill={iconColor}
        />
      }
    >
      <MenuItem
        text={'Logout'}
        icon={<></>}
        onClick={logout}
        menuTextStyle={styles.menuTextStyle}
      />
    </Menu>
  )
}

const styles = StyleSheet.create({
  menuTextStyle: {
    ...TEXT_STYLES.textNeutral80,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...TYPOGRAPHY.TEXT2,
  },
})

export default HeaderMenu
